import { LessonUnderstood } from '@/enums'

/**
 * Returns true if the given lesson understood value is a user selected value.
 *
 * @param {LessonUnderstood} understood
 * @returns {boolean}
 */
export function isUserSelectedUnderstoodValue(understood) {
  return [
    LessonUnderstood.YES,
    LessonUnderstood.SOMEWHAT,
    LessonUnderstood.NO,
  ].includes(understood)
}
